import React from 'react';
// Specific icon component added to make the nav item in the Editor Header visually match the design
function UpSmallForNavItem({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={8}
      height={size}
      viewBox="8 0 8 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path stroke="transparent" fill="currentColor" d="M12 10l3.464 3.75H8.536L12 10z" />
    </svg>
  );
}

export default UpSmallForNavItem;
